module.exports = __webpack_public_path__ + "static/media/plus.e6827c8d.svg";